import Box from '@mui/material/Box';
import { AssignmentSummaryCard } from './AssignmentSummaryCard';
import { FloatingButtons } from './FloatingButtons';
import { Shifts } from './Shifts';

export const WeekDetails = () => {
  return (
    <Box sx={{ mb: 13 }}>
      <AssignmentSummaryCard />
      <Shifts />
      <FloatingButtons />
    </Box>
  );
};
